import React, { Component } from 'react';

import AutoComplete from 'common/components/AutoComplete/AutoComplete';
import R from 'common/res/R';

class BusAgentAutoComplete extends Component {
  render() {
    const {
      sections,
      keyword,
      onClose: handleClose,
      onChangeKeyword: handleChangeKeyword,
      onItemPressed: handleItemPressed,
    } = this.props;

    const headerProps = {
      autoFocus: true,
      placeholder: 'Ketik nama agen',
      value: keyword,
      onChangeText: handleChangeKeyword,
      onClose: handleClose,
      backgroundColor: R.color.brand,
      closeText: 'Tutup',
    };

    return (
      <AutoComplete
        headerProps={headerProps}
        keyExtractor={({ code }) => code}
        sections={sections}
        onItemPressed={handleItemPressed}
      />
    );
  }
}

export default BusAgentAutoComplete;
